import { render, staticRenderFns } from "./Ribbon.vue?vue&type=template&id=09776dd0&scoped=true&"
import script from "./Ribbon.vue?vue&type=script&lang=js&"
export * from "./Ribbon.vue?vue&type=script&lang=js&"
import style0 from "./Ribbon.vue?vue&type=style&index=0&id=09776dd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09776dd0",
  null
  
)

export default component.exports